import React from 'react';
import { Pill } from './design-system/Pill';
import { getCategoryEmoji } from '../data/shared/utils/CategoryEmojiMap.native';
import { formatEarnRate } from '../data/shared/utils/formatEarnRate';
import { formatSpendCategory } from '../data/shared/utils/formatSpendCategory';
import { CreditCardRewardsType } from 'data/shared/CreditCardRewardsTypes';

// CreditPill component for consistent styling
export const CreditPill = ({
  amount,
  frequency,
  name,
  isTotal = false,
  valueUnit,
}: {
  amount?: number | null;
  frequency?: string;
  name: string;
  isTotal?: boolean;
  valueUnit?: string | null;
}) => {
  const formatAmount = () => {
    if (!amount) {
      return '';
    }

    const formattedAmount = amount.toLocaleString();

    // Only add dollar sign if value_unit is 'dollars' or not specified (backward compatibility)
    if (!valueUnit || valueUnit.toLowerCase() === 'dollars') {
      return `$${formattedAmount}${frequency || ''}`;
    }

    // For points, miles, etc., don't add dollar sign
    return `${formattedAmount}${frequency || ''}`;
  };

  return (
    <Pill
      style={{
        backgroundColor: isTotal ? '#eff6ff' : '#EEF1F4',
        color: isTotal ? '#2563eb' : '#333',
        border: isTotal ? '1px solid #dbeafe' : 'none',
        fontWeight: isTotal ? '600' : '400',
      }}
    >
      {formatAmount()}
      <span
        style={{
          fontSize: isTotal ? '14px' : '12px',
          opacity: isTotal ? 1 : 0.8,
        }}
      >
        {name}
      </span>
    </Pill>
  );
};

export const CategoryEarnRatePill = ({
  category,
  earnRate,
  rewardsType,
  style,
  hideEarnRate = false,
  title,
}: {
  category: string;
  earnRate: number;
  rewardsType: CreditCardRewardsType;
  style?: React.CSSProperties;
  hideEarnRate?: boolean;
  title?: string;
}) => {
  return (
    <Pill
      title={title}
      style={{
        marginBottom: '4px',
        ...style,
      }}
    >
      {getCategoryEmoji(category)}{' '}
      {!hideEarnRate && `${formatEarnRate(earnRate, rewardsType)} `}
      {formatSpendCategory(category)}
    </Pill>
  );
};
